import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getData, postData } from '../../../apis/api.helpers'
import apiUrl from '../../../apis/api.url'
import { QueryParams } from '../../../common/types'
import { parseQueryParams } from '../../../utilities/parsers'

const buildUrlWithParams = (baseUrl: string, params: QueryParams) => {
  return `${baseUrl}${parseQueryParams(params)}`
}

const fetchProgramBookings = async (input: QueryParams) => {
  const url = buildUrlWithParams(apiUrl.PROGRAM_BOOKINGS, {
    ...input,
  })
  const response = await getData(url)
  return response
}

export const useFetchProgramBookings = (input: QueryParams) => {
  return useQuery(
    ['program_bookings', input],
    () => fetchProgramBookings(input),
    {}
  )
}

const programBookingDetails = async (id: string) => {
  const url = `${apiUrl.PROGRAM_BOOKINGS}/${id}`
  const response = await getData(url)
  return response
}

export const useProgramBookingDetails = (id: string) => {
  return useQuery(['program_booking', id], () => programBookingDetails(id), {
    refetchOnWindowFocus: false,
  })
}

export interface ProgramFeedbackPayload {
  overall_rating: number
  content_rating: number
  trainer_rating: number
  organization_rating: number
  comments?: string
  suggestions?: string
}

export const useSubmitProgramFeedback = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({
      bookingId,
      data,
    }: {
      bookingId: number
      data: ProgramFeedbackPayload
    }) => postData(`${apiUrl.PROGRAM_BOOKINGS}/${bookingId}/feedback`, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['program_bookings'])
      },
    }
  )
}
